
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    var reg = await navigator.serviceWorker.register(`${window.location.origin}/service-worker.js`, {
      ready() {
        console.log('App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB');
      },
      cached() {
        console.log('Content has been cached for offline use.');
      },
      updated() {
        console.log('New content is available; please refresh.');
        alert('New content is available; please refresh.');
      },
      offline() {
        console.log('No internet connection found. App is running in offline mode.');
      },
      error(error) {
        console.error('Error during service worker registration:', error);
      },
    });
    window.registerSW = reg;
    
    // reload once the new Service Worker starts activating
    var refreshing;
    navigator.serviceWorker.addEventListener('controllerchange',
      function() {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      }
    );
    
  });
}

else {
  console.log('Service worker not registered: not a production environment or service worker not supported by browser.')
}